/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SafeHtmlPipe as ɵa} from './lib/safe-html.pipe';